// KeyCode of keyboard.
export default {
  enter: 13,
  escape: 27,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  space: 32,
  alt: 18,
};
